/* eslint-disable camelcase */
import vcookie from 'vue-cookie';
import toastr from 'mini-toastr';
import { post } from './httpServer';
import bus from '../utils/bus';
import apiService from './apiHelper';

let user;

const NORMAL_USER_KEY = 'NORMAL_USER_KEY';

function handleUserResp(resp) {
  user = resp.data;
  sessionStorage.setItem(NORMAL_USER_KEY, JSON.stringify(user));
  vcookie.set('guid', resp.data.uuid, 2);
  vcookie.set('cid', resp.data.pid, 2);
  bus.$emit('USER_CHANGED');
  return resp;
}

export default {
  hasLogin() {
    if (!user) {
      const userstr = sessionStorage.getItem(NORMAL_USER_KEY);
      if (userstr && userstr !== 'undefined') {
        user = JSON.parse(userstr);
      }
      console.log(userstr);
    }
    return user && user.uuid;
  },
  login(telephone, password) {
    return post('/api/user/login/', { telephone, password }).then(handleUserResp, (resp) => {
      console.log('login error');
      // sessionStorage.removeItem(NORMAL_USER_KEY);
      return resp;
    });
  },
  register(telephone, password, captcha, tele_verify_code) {
    return post('/api/user/register/', { telephone, password, captcha, tele_verify_code }).then(handleUserResp);
  },
  forgetPass(telephone, password, captcha, tele_verify_code) {
    return post('/api/user/forgetpwd/', { telephone, password, captcha, tele_verify_code }).then(handleUserResp);
  },
  getVerifyCode(telephone, captcha, type) {
    return post('/api/common/verify_code/', { telephone, captcha, type }).then((resp) => {
      console.log('success');
      return resp;
    });
  },
  getUser() {
    return user;
  },
  favorCaseInfo(caseInfo) {
    if (!this.hasLogin()) {
      toastr.error('请登录后收藏');
      return;
    }
    apiService.favorCase(caseInfo.id).then(() => {
      this.$set(caseInfo, 'isFavored', true);
    });
  },
  unFavorCaseInfo(caseInfo) {
    if (!this.hasLogin()) {
      toastr.error('请登录后取消收藏');
      return;
    }
    apiService.unFavorCase(caseInfo.id).then(() => {
      this.$set(caseInfo, 'isFavored', false);
    });
  },
  logout() {
    user = {};
    sessionStorage.removeItem(NORMAL_USER_KEY);
    vcookie.delete('guid');
    vcookie.delete('cid');
    bus.$emit('USER_CHANGED');
  },
};



// WEBPACK FOOTER //
// ./src/service/user.js